import React, { Component } from 'react';

class Header extends Component {
  render() {
    return (
      <thead>
        <tr>
          <th rowSpan="2" className="general-cell comp" colSpan={this.props.res.isSmDesktop ? '1' : '2'}>Δ</th>
          <th rowSpan="2" className="time-cell time">Ω/Ε</th>

          {!this.props.res.isMobile &&
            <th rowSpan="2" className="opap-code-cell code">ΚΩΔ.</th>}

          {!this.props.res.isMobilePortrait && <th rowSpan="2" className="general-cell sm ee">Ε/Ε</th>}

          <th rowSpan="2" className="odd-cell em lg">1</th>
          <th rowSpan="2" className="team-cell team">ΓΗΠΕΔΟΥΧΟΣ</th>
          <th rowSpan="2" className="odd-cell em lg">Χ</th>
          <th rowSpan="2" className="team-cell team">ΦΙΛΟΞΕΝΟΥΜΕΝΗ</th>
          <th rowSpan="2" className="odd-cell em lg divider">2</th>

          {!this.props.res.isTablet && !this.props.res.isSmDesktop &&
            <th colSpan="2" className="team-cell divider">
              UNDER / OVER <br /> 2.5 GOALS
            </th>}

          {!this.props.res.isMobile && <th rowSpan="2" className="score-cell score">HM</th>}

          <th rowSpan="2" className="score-cell score">ΣΚΟΡ</th>
          <th rowSpan="2" className="general-cell result"><i className="fa fa-clock-o"></i></th>

          {!this.props.res.isMobile &&
            <th rowSpan="2" className="general-cell lg result">
              <i className="fa fa-line-chart"></i>
            </th>}

          {!this.props.isStatic &&
            <th rowSpan="2" className="general-cell"><i className="fa fa-star"></i></th>}

        </tr>
        {!this.props.res.isTablet && !this.props.res.isSmDesktop &&
          <tr>
            {/*goals*/}
            <th className="odd-cell em">U</th>
            <th className="odd-cell em divider">O</th>
          </tr>}
      </thead>
    )
  }

};

export default Header



// WEBPACK FOOTER //
// ./src/kouponi-header.js